export default __webpack_public_path__ + "static/media/whatsapplogo.35543b46.png";